import React, { useState } from "react";
import {
	Button,
	Box,
	useMediaQuery,
	IconButton,
	Drawer,
	List,
	ListItem,
	ListItemButton,
	ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu"; // Import the menu icon
import Logo from "../assets/logo.png"; // Replace with the path to your logo image
import { SignedIn, SignedOut, useClerk } from "@clerk/clerk-react";

const Header: React.FC = () => {
	const baseUrl = "https://www.criticalmass-consulting.com";
	const isSmallScreen = useMediaQuery("(max-width:600px)");
	const [drawerOpen, setDrawerOpen] = useState(false);
	const { signOut } = useClerk();

	const toggleDrawer =
		(open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
			if (
				event.type === "keydown" &&
				((event as React.KeyboardEvent).key === "Tab" ||
					(event as React.KeyboardEvent).key === "Shift")
			) {
				return;
			}
			setDrawerOpen(open);
		};

	const menuItems = [
		{ text: "Services", href: `${baseUrl}/services-1` },
		{ text: "About Us", href: `${baseUrl}/about` },
		{ text: "Blog", href: `${baseUrl}/blog` },
		{ text: "Careers", href: `${baseUrl}/careers` },
		{ text: "Contact", href: `${baseUrl}/contact-1` },
	];

	const list = () => (
		<Box
			sx={{ width: 250 }}
			role="presentation"
			onClick={toggleDrawer(false)}
			onKeyDown={toggleDrawer(false)}
		>
			<List>
				{menuItems.map((item, index) => (
					<ListItem key={index} disablePadding>
						<ListItemButton component="a" href={item.href}>
							<ListItemText primary={item.text} />
						</ListItemButton>
					</ListItem>
				))}
			</List>
		</Box>
	);

	return (
		<Box
			component="header"
			sx={{
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				borderBottom: 1,
				borderColor: "divider",
				backgroundColor: "background.paper",
				height: isSmallScreen ? "56px" : "64px",
				padding: isSmallScreen ? "0 10px" : "0 20px",
			}}
		>
			<Box sx={{ display: "flex", alignItems: "center" }}>
				<Button href={baseUrl}>
					<img
						src={Logo}
						alt="Critical Mass Consulting, LLC"
						style={{ height: isSmallScreen ? "30px" : "50px" }}
					/>
				</Button>
				{isSmallScreen && (
					<IconButton
						color="inherit"
						aria-label="open drawer"
						edge="start"
						onClick={toggleDrawer(true)}
					>
						<MenuIcon sx={{ color: "#7B2855" }} />
					</IconButton>
				)}
			</Box>
			{isSmallScreen ? (
				<Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
					{list()}
					<SignedOut>
						<Button color="inherit" href="/login">
							Login
						</Button>
					</SignedOut>
					<SignedIn>
						<Button color="inherit" onClick={() => signOut()}>
							Logout
						</Button>{" "}
					</SignedIn>
				</Drawer>
			) : (
				<Box>
					{menuItems.map((item, index) => (
						<Button key={index} color="inherit" href={item.href}>
							{item.text}
						</Button>
					))}
					<SignedOut>
						<Button color="inherit" href="/login">
							Login
						</Button>
					</SignedOut>
					<SignedIn>
						<Button color="inherit" onClick={() => signOut()}>
							Logout
						</Button>{" "}
					</SignedIn>
				</Box>
			)}
		</Box>
	);
};

export default Header;
